export default function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}


//////////////////
// WEBPACK FOOTER
// /data/websites/sparkasse.it/httpdocs/wp-content/themes/g2k-sparkasse/sito-investor-relations/node_modules/@popperjs/core/lib/utils/mergeByName.js
// module id = 73
// module chunks = 0